import { graphql, useStaticQuery } from 'gatsby'
import { getDataByLocale } from '~/hooks/utils/get-data-by-locale'
/* 
  SUPPORT LOCALE HERE

  "en-US"
  "fr-CA"
  "en-CA"
  "he-IL"
  "es-MX"
  */
const useFooterQuery = locale => {
  const data = useStaticQuery(
    graphql`
      query FooterQuery {
        social: contentfulSiteMetadata {
          facebookUsername
          instagramUsername
          tiktokUsername
          twitterUsername
          pinterestUsername
          linkedinUsername
          spotifyUsername
        }
        # ENGLISH US
        catalog_enUS: contentfulCatalog(
          slug: { eq: "catalog" }
          node_locale: { eq: "en-US" }
        ) {
          collections {
            __typename
            id
            title
            slug
            hidden
          }
        }
        links_enUS: contentfulNavigationBar(
          slug: { eq: "footer-links" }
          node_locale: { eq: "en-US" }
        ) {
          tabs {
            ...NavSectionFragment
            ... on ContentfulPage {
              __typename
              id
              name
              slug
            }
          }
        }

        legal_enUS: contentfulNavigationBar(
          slug: { eq: "footer-legal" }
          node_locale: { eq: "en-US" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        # ENGLISH CA
        catalog_enCA: contentfulCatalog(
          slug: { eq: "catalog" }
          node_locale: { eq: "en-CA" }
        ) {
          collections {
            __typename
            title
            slug
            hidden
          }
        }
        links_enCA: contentfulNavigationBar(
          slug: { eq: "footer-links" }
          node_locale: { eq: "en-CA" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                __typename
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        legal_enCA: contentfulNavigationBar(
          slug: { eq: "footer-legal" }
          node_locale: { eq: "en-CA" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        # FRENCH CA
        catalog_frCA: contentfulCatalog(
          slug: { eq: "catalog" }
          node_locale: { eq: "fr-CA" }
        ) {
          collections {
            __typename
            title
            slug
            hidden
          }
        }
        links_frCA: contentfulNavigationBar(
          slug: { eq: "footer-links" }
          node_locale: { eq: "fr-CA" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                __typename
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        legal_frCA: contentfulNavigationBar(
          slug: { eq: "footer-legal" }
          node_locale: { eq: "fr-CA" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        # HEBREW IL
        catalog_heIL: contentfulCatalog(
          slug: { eq: "catalog" }
          node_locale: { eq: "he-IL" }
        ) {
          collections {
            __typename
            title
            slug
            hidden
          }
        }
        links_heIL: contentfulNavigationBar(
          slug: { eq: "footer-links" }
          node_locale: { eq: "he-IL" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                __typename
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        legal_heIL: contentfulNavigationBar(
          slug: { eq: "footer-legal" }
          node_locale: { eq: "he-IL" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                ... on ContentfulPage {
                  __typename
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  __typename
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              __typename
              id
              name
              slug
            }
          }
        }

        # SPANISH MX

        catalog_esMX: contentfulCatalog(
          slug: { eq: "catalog" }
          node_locale: { eq: "es-MX" }
        ) {
          collections {
            __typename
            title
            slug
            hidden
          }
        }
        links_esMX: contentfulNavigationBar(
          slug: { eq: "footer-links" }
          node_locale: { eq: "es-MX" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                __typename
                ... on ContentfulPage {
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              id
              name
              slug
            }
          }
        }

        legal_esMX: contentfulNavigationBar(
          slug: { eq: "footer-legal" }
          node_locale: { eq: "es-MX" }
        ) {
          tabs {
            ... on ContentfulNavSection {
              id
              navSectionName
              navSectionTitle
              pages {
                ... on ContentfulPage {
                  __typename
                  id
                  name
                  slug
                }
                ... on ContentfulCollection {
                  __typename
                  id
                  name
                  slug
                }
              }
            }
            ... on ContentfulPage {
              __typename
              id
              name
              slug
            }
          }
        }
      }
    `,
  )

  return {
    ...data,
    catalog: getDataByLocale(locale, data, 'catalog_'),
    links: getDataByLocale(locale, data, 'links_'),
    legal: getDataByLocale(locale, data, 'legal_'),
  }
}

export default useFooterQuery
